module.exports = __webpack_public_path__ + "baselinker.svg?237172eac3966c802b25b8d2b38374ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/baselinker.svg
// module id = 278
// module chunks = 2